<template>
  <div
    v-if="show"
    class="twig-confirmation-modal fixed left-0 top-0 z-[19999] box-border grid h-full w-full items-center justify-center overflow-auto bg-black/[.65] pt-1.5"
    @click.self="onCancelButtonClick('outside')"
  >
    <div
      class="relative m-auto min-w-[380px] overflow-hidden rounded-xl bg-gray-700 p-5"
    >
      <div class="mb-7 font-inter text-base font-bold leading-4 text-gray-50">
        <slot class="title" name="header" />
        <TButton
          class="!absolute right-[8px] top-[8px]"
          @click="onCancelButtonClick()"
        >
          <template #icon>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.9609 5.48438C14.2422 5.17969 14.7344 5.17969 15.0156 5.48438C15.3203 5.76562 15.3203 6.25781 15.0156 6.53906L11.0547 10.5L15.0156 14.4844C15.3203 14.7656 15.3203 15.2578 15.0156 15.5391C14.7344 15.8438 14.2422 15.8438 13.9609 15.5391L10 11.5781L6.01562 15.5391C5.73438 15.8438 5.24219 15.8438 4.96094 15.5391C4.65625 15.2578 4.65625 14.7656 4.96094 14.4844L8.92188 10.5L4.96094 6.53906C4.65625 6.25781 4.65625 5.76562 4.96094 5.48438C5.24219 5.17969 5.73438 5.17969 6.01562 5.48438L10 9.44531L13.9609 5.48438Z"
                fill="currentColor"
              />
            </svg>
          </template>
        </TButton>
      </div>
      <div
        class="flex grow items-center font-inter text-sm font-medium leading-[1.5] text-gray-100"
      >
        <slot />
      </div>
      <div class="mt-5 flex justify-end gap-2">
        <t-button data-testid="cancel" @click="onCancelButtonClick"
          >Cancel</t-button
        >
        <t-button
          data-testid="confirm"
          :disabled="disabled"
          :danger="!success"
          :success="success"
          @click="onOkButtonClick"
        >
          <template v-if="!success && !noIcon" #icon>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6875 0.875H9.40625L9.13281 0.382812C9.02344 0.164062 8.77734 0 8.55859 0L5.41406 0C5.19531 0 4.92188 0.164062 4.83984 0.382812L4.59375 0.875H1.3125C1.06641 0.875 0.875 1.09375 0.875 1.3125V2.1875C0.875 2.43359 1.06641 2.625 1.3125 2.625H12.6875C12.9062 2.625 13.125 2.43359 13.125 2.1875V1.3125C13.125 1.09375 12.9062 0.875 12.6875 0.875ZM2.32422 12.7695C2.35156 13.4531 2.95312 14 3.63672 14H10.3359C11.0195 14 11.6211 13.4531 11.6484 12.7695L12.25 3.5H1.75L2.32422 12.7695Z"
                fill="white"
              />
            </svg>
          </template>
          <slot name="confirm-action" />
        </t-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TButton from "../TButton/TButton.vue";
import { ref, onMounted, onBeforeUnmount } from "vue";

const show = ref(false);
const resolve = ref<any>();

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  success: {
    type: Boolean,
    default: false,
  },
  noIcon: {
    type: Boolean,
    default: false,
  },
  closeOutNo: {
    type: Boolean,
    default: false,
  },
});

const open = async () => {
  return new Promise((res) => {
    resolve.value = res;
    show.value = true;
  });
};

const onOkButtonClick = () => {
  show.value = false;
  resolve.value && resolve.value("ok");
};

const onCancelButtonClick = (type?: string) => {
  if (!(type === "outside" && props.closeOutNo)) {
    show.value = false;
    resolve.value && resolve.value("cancel");
  }
};

function confirmByEnter(event: KeyboardEvent) {
  if (event.key === "Enter") {
    onOkButtonClick();
  }
}

defineExpose({
  open,
});

onMounted(() => {
  window.addEventListener("keydown", confirmByEnter);
});
onBeforeUnmount(() => {
  window.removeEventListener("keydown", confirmByEnter);
});
</script>
